import SidebarLayout from "../../../../layouts/SidebarLayout";
import sidebar from "../../utils/sidebar";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { useCallback, useEffect, useMemo, useState } from "react";
import { get } from "../../../../utils/helpers/api";
import { AgGridReact } from "ag-grid-react";
import PageSubHeader from "../../../../components/Layouts/PageSubHeader";
import DefaultButton from "../../../../components/Buttons/Default";
import DefaultPagination from "../../../../components/Pagination";
import IconButton from "../../../../components/Buttons/IconButton";
import { IoCreateOutline } from "react-icons/io5";
import CreateDrawer from "./Drawers/create";
import { useTranslation } from "react-i18next";
import AgGridTable from "../../../../components/Tables/AgGrid";

ModuleRegistry.registerModules([AllCommunityModule]);

function ActionsCellRenderer({ data, context }) {
  return (
    <div className="d-flex align-items-center gap-2 h-100">
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          context.setEditData(data);
          context.setCreateDrawerOpen(true);
        }}
        size="sm" outline color="secondary"
      >
        <IoCreateOutline />
      </IconButton>
    </div>
  );
}

function RolesPage() {
  const { t } = useTranslation();
  const [rowData, setRowData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [createDrawerOpen, setCreateDrawerOpen] = useState(false);
  const [editData, setEditData] = useState(null);

  const getRoles = useCallback(async () => {
    setLoading(true);
    const data = await get('/settings/roles?page=' + currentPage + '&page_size=' + pageSize);
    if (data?.roles?.data) {
      setRowData(data.roles.data);
      setTotalPages(data.roles.last_page);
    }
    setLoading(false);
  }, [currentPage, pageSize]);

  useEffect(() => {
    getRoles();
  }, [getRoles]);

  const columnDefs = useMemo(() => [
    { field: 'name', headerName: t('settings.roles'), flex: 1, sortable: true },
    {
      field: 'permissions',
      headerName: t('settings.permission'),
      flex: 1,
      sortable: false,
      wrapText: true,
      autoHeight: true,
      cellStyle: { lineHeight: '1.5', paddingTop: '8px', paddingBottom: '8px' },
      valueFormatter: ({ value }) => Array.isArray(value) ? value.map(p => p.name_en).join(', ') : '',
    },
    { headerName: t('common.options'), width: 110, sortable: false, resizable: false, cellRenderer: ActionsCellRenderer }
  ], [t]);

  const defaultColDef = useMemo(() => ({ resizable: true }), []);
  const gridContext = useMemo(() => ({ setCreateDrawerOpen, setEditData }), []);

  return(
    <SidebarLayout sidebar={sidebar}>
      <div className="page-with-subheader">
        <PageSubHeader title={t('settings.roles')}>
          <DefaultButton color="primary" size="sm" onClick={() => { setCreateDrawerOpen(true); setEditData(null); }}>
            {t('settings.newRole')}
          </DefaultButton>
        </PageSubHeader>

        <div className="subheader-page-content">
          <AgGridTable 
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            loading={loading}
            context={gridContext}
          />

          <DefaultPagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
        </div>
      </div>

      <CreateDrawer
        isOpen={createDrawerOpen}
        toggle={() => setCreateDrawerOpen(false)}
        editData={editData}
        onSaved={() => { getRoles(); setEditData(null); }}
      />
    </SidebarLayout>
  );
}

export default RolesPage;
